import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3caeaa0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show--title" }
const _hoisted_2 = ["title", "href"]
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { class: "show--body" }
const _hoisted_5 = { class: "show--links" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Peppermill Concert Hall, Wendover NV", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Price")
  ])
], -1 /* HOISTED */))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "SHOW CANCELED", -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "show--cell-sold_out"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { key: 5 }
const _hoisted_20 = { key: 6 }
const _hoisted_21 = {
  key: 0,
  class: "show--cta"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_show_button_on_sale_countdown = _resolveComponent("show-button-on-sale-countdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["show--container", _ctx.containerClasses])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.show.show_title), 1 /* TEXT */),
    (_ctx.show.image && _ctx.show.image.image_type)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          title: 'View ' + _ctx.show.show_title,
          href: _ctx.showUrlPath
        }, [
          _createElementVNode("div", {
            class: "show--image",
            style: _normalizeStyle(_ctx.imageStyles)
          }, [
            _createElementVNode("img", {
              class: "show--print_image",
              alt: _ctx.show.show_title,
              src: _ctx.imageUrlPath
            }, null, 8 /* PROPS */, _hoisted_3)
          ], 4 /* STYLE */)
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, [
        _createElementVNode("a", {
          href: _ctx.showUrlPath,
          title: "View More Information"
        }, "More Information", 8 /* PROPS */, _hoisted_6),
        (_ctx.show.show_link.length)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.show.show_link,
              target: "_blank",
              rel: "noopener noreferrer",
              title: "Visit This Act's Website"
            }, "Visit This Act's Website", 8 /* PROPS */, _hoisted_7))
          : _createCommentVNode("v-if", true)
      ]),
      _hoisted_8,
      _createElementVNode("table", null, [
        _hoisted_9,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_ctx.showDateString), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(_ctx.showTime), 1 /* TEXT */),
            _createCommentVNode(" START: Logic for show price "),
            (_ctx.show.show_canceled)
              ? (_openBlock(), _createElementBlock("td", _hoisted_10, _hoisted_12))
              : (_ctx.show.show_sold_out && (_ctx.show.show_vip_sold_out || !_ctx.show.show_vip_link.length))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.isPackageAvailable)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                          _createElementVNode("a", {
                            href: '/shows/concert-hall-packages/#s-' + _ctx.packageName
                          }, "See Packages", 8 /* PROPS */, _hoisted_14)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_15, "SOLD OUT"))
                  ], 64 /* STABLE_FRAGMENT */))
                : (_ctx.show.show_price_low === _ctx.show.show_price_high && 0 !== _ctx.show.show_price_low)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_16, " $" + _toDisplayString(_ctx.show.show_price_low.toFixed(2)), 1 /* TEXT */))
                  : (_ctx.show.show_price_low > 0 && _ctx.show.show_price_high > 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, "$" + _toDisplayString(_ctx.show.show_price_low.toFixed(2)) + " to $" + _toDisplayString(_ctx.show.show_price_high.toFixed(2)), 1 /* TEXT */))
                    : (_ctx.show.show_price_low > 0)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_18, "$" + _toDisplayString(_ctx.show.show_price_low.toFixed(2)) + " and up", 1 /* TEXT */))
                      : (_ctx.show.show_price_high > 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_19, "$" + _toDisplayString(_ctx.show.show_price_high.toFixed(2)), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("td", _hoisted_20, " ")),
            _createCommentVNode(" END: Logic for show price ")
          ])
        ])
      ]),
      (!_ctx.show.show_canceled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (_ctx.isAvailableToBook)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "generic-btn",
                  href: _ctx.bookingLink,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBookingLinkClick && _ctx.handleBookingLinkClick(...args)), ["prevent","stop"]))
                }, " Buy Tickets Now ", 8 /* PROPS */, _hoisted_22))
              : (_ctx.isAvailableToBookInFuture)
                ? (_openBlock(), _createBlock(_component_show_button_on_sale_countdown, {
                    key: 1,
                    "on-sale-date": _ctx.onSaleDate,
                    onOnSaleNow: _ctx.updateOnSale
                  }, null, 8 /* PROPS */, ["on-sale-date", "onOnSaleNow"]))
                : _createCommentVNode("v-if", true),
            (_ctx.isPackageAvailable)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  class: "generic-btn package-btn",
                  href: '/shows/concert-hall-packages/#s-' + _ctx.packageName,
                  style: {"margin-left":"0","margin-right":"0"}
                }, "Package Available", 8 /* PROPS */, _hoisted_23))
              : _createCommentVNode("v-if", true),
            (_ctx.show.show_vip_link.length)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  class: "generic-btn",
                  href: _ctx.show.show_vip_link,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "VIP PACKAGE", 8 /* PROPS */, _hoisted_24))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}